import { z } from "zod";

import i18n from "@/i18n";

export const positionSchema = z.object({
	name: z
		.string()
		.trim()
		.superRefine((value, ctx) => {
			if (!value) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: i18n.t("discounts.nameRequired"),
				});
			}
		}),
	sortOrder: z.number().int().min(0),
	isActive: z.boolean(),
});

export type PositionFormValues = z.infer<typeof positionSchema>;
